/**
 * ============================================================
 * TRESTLE™ Configuration
 * ------------------------------------------------------------
 * Central configuration for the TRESTLE frontend.
 *
 * Responsibilities
 * ----------------
 * • Application settings
 * • API configuration
 * • Session configuration
 * • Authentication states
 * • Membership configuration
 *
 * Parent Brand : Diafemme
 * Version      : 2.0
 * Status       : PRODUCTION
 * ============================================================
 */

'use strict';

const TrestleConfig = (() => {

    /*==========================================================
    APPLICATION
    ==========================================================*/

    const APP = {

        NAME: "TRESTLE",

        VERSION: "2.0",

        ENVIRONMENT: "PRODUCTION"

    };

    /*==========================================================
    API
    ==========================================================*/

    const API = {

        BASE_URL:
            "https://script.google.com/macros/s/AKfycbzpSAQfsqxntX5xQKsC8q0By1ebqS7tPex8_rPaPFYGTPIUk3633-z5YNKcLBV5RbGM/exec",

        TIMEOUT: 30000

    };

    /*==========================================================
    SESSION
    ==========================================================*/

    const SESSION = {

        STORAGE_KEY: "trestleEmail",

        USER_ID: "trestleUserId",

        WORKSPACE_ID: "trestleWorkspaceId",

        SESSION_TOKEN: "trestleSessionToken",

        LAST_LOGIN: "trestleLastLogin",

        REMEMBER_ME: "trestleRememberMe",

        TIMEOUT: 86400

    };

    /*==========================================================
    AUTHENTICATION STATES
    ==========================================================*/

    const AUTH = {

        IDLE: "IDLE",

        VALIDATING: "VALIDATING",

        SENDING_LINK: "SENDING_LINK",

        LINK_SENT: "LINK_SENT",

        AUTHENTICATED: "AUTHENTICATED",

        REGISTERING: "REGISTERING",

        READY: "READY",

        ERROR: "ERROR"

    };

    /*==========================================================
    REGISTRATION
    ==========================================================*/

    const REGISTRATION = {

        INDIVIDUAL: "INDIVIDUAL",

        CORPORATE: "CORPORATE",

        PILOT: "PILOT",

        ADMIN: "ADMIN"

    };

    /*==========================================================
    MEMBERSHIP
    ==========================================================*/

    const MEMBERSHIP = {

        FREE: "FREE",

        PREMIUM: "PREMIUM",

        CORPORATE: "CORPORATE",

        PILOT: "PILOT"

    };

    /*==========================================================
    WORKSPACE
    ==========================================================*/

    const WORKSPACE = {

        DEFAULT_NAME: "My Health",

        DEFAULT_TYPE: "PERSONAL",

        DEFAULT_VISIBILITY: "PRIVATE"

    };

    /*==========================================================
    API ACTIONS
    ==========================================================*/

    const ACTIONS = {

        LOGIN: "LOGIN",

        LOAD_DASHBOARD: "LOAD_DASHBOARD",

        LOAD_WORKSPACE: "LOAD_WORKSPACE",

        CREATE_WORKSPACE: "CREATE_WORKSPACE",

        LOAD_HEALTH_LOG: "LOAD_HEALTH_LOG",

        CREATE_HEALTH_LOG: "CREATE_HEALTH_LOG",

        LOAD_REPORT: "LOAD_REPORT",

        CREATE_REPORT: "CREATE_REPORT"

    };

    /*==========================================================
    MESSAGES
    ==========================================================*/

    const MESSAGE = {

        INVALID_EMAIL:
            "Please enter a valid email address.",

        MAGIC_LINK_SENT:
            "We've sent a secure sign-in link to your email. If you don't see it within a minute, please check your Spam or Junk folder.",

        REGISTRATION_SUCCESS:
            "Your TRESTLE workspace has been created.",

        SERVER_ERROR:
            "Something went wrong. Please try again."

    };

    /*==========================================================
    PUBLIC API
    ==========================================================*/

    return {

        APP,

        API,

        SESSION,

        AUTH,

        REGISTRATION,

        MEMBERSHIP,

        WORKSPACE,

        ACTIONS,

        MESSAGE

    };

})();

/*============================================================
GLOBAL CONFIGURATION
============================================================*/

window.TrestleConfig = TrestleConfig;